// @ts-nocheck
import Vue from 'vue'
import App from './App.vue'
import router from './router/index.js'
import ElementUI from 'element-ui';
import * as filters from './filters'
import store from '@/store/index.js';
import 'element-ui/lib/theme-chalk/index.css';
import './style/base.css'
import '@/utils/permission'

import components from '@/utils/components.js'
Vue.use(components)


import axios from "axios";
// 过滤日期时间的
import moment from 'moment'
//手动引入所需要的语言包
import 'moment/locale/zh-cn';
moment.locale('zh-cn');
// 聊天组件
// import Chat from 'jwchat';
import JwChat from '@/components/Chat'
// import 'jwchat/lib/JwChat.css';
Vue.use(JwChat)
Vue.use(ElementUI);
Vue.config.productionTip = false
Vue.prototype.$moment = moment

Vue.prototype.$axios = axios

// import JsonExcel from 'vue-json-excel'

// Vue.component('downloadExcel', JsonExcel)

// 全局注册过滤器
Object.keys(filters).forEach(key => {
    Vue.filter(key, filters[key])
})

new Vue({
    render: h => h(App),
    router,
    store
}).$mount('#app')